import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { AlertCircle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface DiscardChangesDialogProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const DiscardChangesDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: DiscardChangesDialogProps) => {
  return (
    <Dialog
      onClose={onCancel}
      actions={{
        primary: {
          icon: AlertCircle,
          label: i18n.t('pages.upload_files_modal.discard_dialog.button_discard'),
          onClick: onConfirm,
          variant: 'critical',
        },
        secondary: {
          label: i18n.t('common.continue'),
          onClick: onCancel,
        },
      }}
      header={{
        description: i18n.t('pages.upload_files_modal.discard_dialog.description'),
        title: i18n.t('pages.upload_files_modal.discard_dialog.title'),
        type: 'critical',
      }}
      open={isOpen}
    />
  )
}
